// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1njkZ","title":"Header_title__3Gnrz","side":"Header_side__3WHeK"};